import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

interface DatenadapterCredentials {
  username: string;
  password: string;
  apiUrl: string;
}

export async function getDatenadapterCredentials(): Promise<DatenadapterCredentials> {
  try {
    const data = await authenticatedFetchJson<DatenadapterCredentials>("/api/datenadapter-credentials", {
      method: "GET",
    });

    return {
      username: data.username || "",
      password: data.password || "",
      apiUrl: data.apiUrl || ""
    };
  } catch (error) {
    console.error("Error fetching Datenadapter credentials:", error);
    return { username: "", password: "", apiUrl: "" };
  }
}
